import { mapActions } from 'vuex'
import { clone } from 'ramda'
import Vue from 'vue'
import { eventService } from '@/services/event.service'
import { filterRulesMapped } from '@/tools/filterRules'


export default {
    name: 'AlertEventDialogEventsTabComponent',
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // loading del selector de cosas
        loadingEvents:  false,
        // headers
        tableHeaders: [],
        // reglas de filtrado
        tableFilterRules: {},
        // datos
        tableData: [],
        // key de los dato de la tabla
        tableDataKey: '_id',
        // botones del componente Tabla
        tableComponentButtons: [],
        // tamaño de página
        pageSize: undefined,
        // núm de página
        pageNumber: undefined,
        // total de elementos de la base de datos
        pageTotal: 0,
        // loading de la tabla
        loadingTable: true
    }),
    computed: {
    },
    created () {
    },
    mounted () {
        this.initialize()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        /**
         * Para inicializar el componente
         */
        async initialize () {
            // cargo la tabla
            this.getData()
        },
        /**
         * Obtiene los datos para la tabla del ABM
         * @param {*} update
         */
        async getData(update = false) {
            this.loadingTable = true
            const data = await eventService.findAllEventType(this.pageSize, this.pageNumber, !update)
            const lastTableHeaders = clone(this.tableHeaders)
            this.tableData.cleanAndUpdate(data.data)
            if (update) {
                const that = this
                Vue.nextTick(function () {
                    that.tableHeaders.cleanAndUpdate(lastTableHeaders)
                })
            } else {
                this.tableHeaders.cleanAndUpdate(data.headers)
                this.setTableFilterRules()
            }
            this.loadingTable = false
        },
        /**
         * Refrescar la data
         */
        refreshTable() {
            this.getData(true)
        },
        /**
         * Setea las reglas de filtrado
         */
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
        /**
         * Click en un botón de una fila
         * @param {*} data
         */
        rowButtonClicked(data) {
            if(data.allClicked) {
                this.model.eventIds.cleanAndUpdate(data.selectedValues.map(val => val._id));
            } else {
                const that = this;
                if(data.items) {
                    data.items.forEach(el => {
                        if(data.value) 
                            that.model.eventIds.cleanAndUpdate([...that.model.eventIds, el._id])
                        else if(that.model.eventIds.includes(el._id))
                            that.model.eventIds.cleanAndUpdate(that.model.eventIds.filter(e => e !== el._id))            
                    })
                }
                else if(data.item) {
                    if(data.value)
                        that.model.eventIds.cleanAndUpdate([...that.model.eventIds, data.item._id])
                    else if(that.model.eventIds.includes(data.item._id))
                        that.model.eventIds.cleanAndUpdate(that.model.eventIds.filter(el => el !== data.item._id))
                }
            }
            this.model.eventIds.length > 0? this.isValidForm = true : this.isValidForm = false; 
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.model.eventIds.length > 0 ? this.isValidForm = true : this.isValidForm = false;
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.alertEventDialogEventTabForm) {
                this.$refs.alertEventDialogEventTabForm.resetValidation()
            }
        }
    }
}
